<template>
    <div v-if="options" class="article_vertical_head">
        <div class="article_vertical_head__vertical_corner">
                    <span class="article_vertical_head__vertical_corner__text" :class="[ 
                    options.position]" v-html="options.text"></span>
            <img class="article_vertical_head__vertical_corner__image_border"
                 src="~@/assets/images/commons/article-vertical-head.png"/>
        </div>
        <div class="article_vertical_head__author_image">

            <image-with-descriptions :options="{
                        image : options.imageAuthor,
                        descriptions: [
                                {
                                    text: `&copy;EDF`,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'vertical' // vertical, horizontal
                                },
                        ]
                    }"/>
        </div>

    </div>
</template>

<script>
export default {
    name: "ArticleVerticalHead",
    props: {
        options: null,
    }
}
</script>

<style scoped lang="scss">

.article_vertical_head {
    @apply relative inline-block;
    @apply mx-auto md:w-96 ml-20 md:ml-32 lg:mb-5 lg:mr-5 lg:ml-0;
    @media screen and (max-width: 768px) {
        max-width: 250px;
    }
    // min-width: 370px;

    &__vertical_corner {
        @apply absolute bottom-0  transform -rotate-90 origin-bottom-left -ml-3;
        &__text {
            @apply absolute;
            @apply bottom-0 left-16 sm:left-44 md:left-24 lg:left-44;
            @apply text-nandor whitespace-nowrap text-xs md:text-xl lg:text-3xl font-bold;
        }

        &__image_border {
            @apply relative h-14 ml-5 md:h-32 lg:hidden 2xl:block;
        }
    }
}
</style>
